import client from './client';

export const uploadImage = (wildfireId, file, { description = '', isSensitive = false } = {}, onProgress) => {
  const formData = new FormData();
  formData.append('wildfire_id', wildfireId);
  formData.append('description', description);
  formData.append('is_sensitive', isSensitive);
  formData.append('file', file);

  return client
    .post('/images/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress
        ? (evt) => onProgress(evt.total ? evt.loaded / evt.total : 0)
        : undefined,
    })
    .then((r) => r.data);
};

export const listPendingImages = (params) =>
  client.get('/images/pending-moderation', { params }).then((r) => r.data);

export const moderateImage = (id, data) =>
  client.put(`/images/${id}/moderate`, data).then((r) => r.data);

export const updateImage = (id, data) =>
  client.put(`/images/${id}`, data).then((r) => r.data);

export const listPendingVideos = (params) =>
  client.get('/videos/pending-moderation', { params }).then((r) => r.data);

export const moderateVideo = (id, data) =>
  client.put(`/videos/${id}/moderate`, data).then((r) => r.data);

export const updateVideo = (id, data) =>
  client.put(`/videos/${id}`, data).then((r) => r.data);

export const getImageUrl = (filePath) =>
  `${client.defaults.baseURL}/images/file/${filePath}`;

export const getVideoUrl = (filePath) =>
  `${client.defaults.baseURL}/videos/file/${filePath}`;
